import styled from 'styled-components';
import React from 'react';
import ReactDOM from 'react-dom';
import {SidebarBox, SidebarContent} from './SidebarBox';
import {inContainerFormControlColors} from '../../../shared-components/variables/componentColors/formControlVariableColors';
import {colorTheme} from '../../mixin/colorTheme';
import {ScrollBar} from '../../../shared-components/mixin/scroll/scrollBar';

const FixedSidebar = styled(ScrollBar)`
    ${inContainerFormControlColors};
    ${colorTheme({
        '--fixed-sidebar-scroll-thumb      ': {dark: 'var(--black-14)  ', light: 'var(--gray-02)'},
    })};
    background: var(--container-background-color-600);
    box-shadow: var(--container-shadow-color-500);
    width: var(--sidebar-width);
    overflow-y: auto;
    z-index: var(--z-index-navigation-fixed-sidebar);
    position: fixed;
    height: 100vh;
    transform: translateY(calc(0px - var(--grid-padding)));

    padding-bottom: 200px;
    --scroll-bar-background: var(--container-background-color-600) !important;
    --scroll-bar-thumb: var(--fixed-sidebar-scroll-thumb) !important;
    --scroll-bar-thumb-hover: var(--container-background-color-600) !important;

    ${({size}) => {
        if (size === 'large')
            return `
        width: var(--large-sidebar-width);
        `;
        else return ``;
    }}
`;

export const PortalSidebar = ({children, size, show}) => {
    if (!show) return null;
    return ReactDOM.createPortal(
        <FixedSidebar size={size}>{children}</FixedSidebar>,
        document.getElementById('sidebarGridPortal'),
    );
};

FixedSidebar.Box = SidebarBox;
FixedSidebar.Content = SidebarContent;
export {FixedSidebar, SidebarBox, SidebarContent};
